/* eslint-disable react-hooks/rules-of-hooks */
import { useTranslation } from "react-i18next";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { InitialRequestConfig } from "../models/flexible/initial-request";
import { GeneralFieldController } from "./general-field-controller";
import { GET_PREVIOUS_INTERVENTION_PATIENTS } from "./queries";

enum CaobPhysician {
	Physician_1 = "PHYSICIAN_1",
	OtherPhysicianOtherHospital = "OTHER_PHYSICIAN_OTHER_HOSPITAL",
}

export class ResponsiblePhysicianAliasFieldController extends GeneralFieldController {
	getInitialRequestComponents(): InitialRequestConfig {
		return this.parent.context.isEditable
			? {
					queries: [GET_PREVIOUS_INTERVENTION_PATIENTS],
					variables: { previousInterventionTypeId: this.parent.context.entityType?.id },
			  }
			: { queries: [], variables: {} };
	}

	override useControlProps(): FlexControlProps {
		const { t } = useTranslation();
		const options = [
			{
				label: t(CaobPhysician.Physician_1),
				value: CaobPhysician.Physician_1,
			},
			{
				label: t(CaobPhysician.OtherPhysicianOtherHospital),
				value: CaobPhysician.OtherPhysicianOtherHospital,
			},
		];

		return {
			controlType: "typeahead",
			property: "value",
			optionLabel: "label",
			selectPropertyValue: true,
			options,
		};
	}
}
